import { css, html, LitElement } from "lit";
import { defineComponent } from "../../configuration/utils.js";
import { navVar, semanticVar } from "../styles.js";
const listItemVar = (name) => navVar(`list-item-${name}`);
export class NavTreeNode extends LitElement {
    constructor() {
        super();
        this.label = "";
        this.isCurrent = false;
        this.level = 0;
    }
    render() {
        return html ` <li>${this.label}</li> `;
    }
}
NavTreeNode.properties = {
    label: { type: String, reflect: true, attribute: true },
    isCurrent: { type: Boolean, reflect: true, attribute: "is-current" },
    level: { type: Number, reflect: true },
};
NavTreeNode.styles = [
    css `
      :host([level="0"]) li {
        padding-left: ${listItemVar("padding")};
      }
      :host([level="1"]) li {
        padding-left: calc(1 * ${listItemVar("padding")} + 2.25rem);
      }
      :host([level="2"]) li {
        padding-left: calc(2 * ${listItemVar("padding")} + 2.25rem);
      }
      :host([level="3"]) li {
        padding-left: calc(3 * ${listItemVar("padding")} + 2.25rem);
      }
      :host([level="4"]) li {
        padding-left: calc(4 * ${listItemVar("padding")} + 2.25rem);
      }
      li {
        list-style: none;
        padding-left: ${listItemVar("padding")};
        padding-right: ${listItemVar("padding")};
        padding-top: calc(${listItemVar("padding")} / 2);
        padding-bottom: calc(${listItemVar("padding")} / 2);
        color: ${listItemVar("default-color")};
        font-size: calc(${listItemVar("font-size")} - 0.1rem);
        line-height: ${listItemVar("line-height")};
        font-weight: ${listItemVar("font-weight")};
        letter-spacing: ${listItemVar("letter-spacing")};
        border-radius: ${listItemVar("border-radius")};
      }
      :host([is-current]) li {
        background: ${listItemVar("current-background-color")};
        color: ${listItemVar("current-color")};
        &:not(:disabled):hover {
          background: ${listItemVar("current-background-color")};
        }
      }
      @media (hover) {
        li:not(.disabled) {
          cursor: pointer;
        }
        li:not(.disabled):hover {
          background-color: ${listItemVar("hover-background-color")};
        }
        li:not(.disabled):focus,
        li:not(.disabled):focus-visible {
          outline-style: solid;
          outline-width: ${semanticVar("border-width-focus-width")};
          outline-color: ${semanticVar("color-color-gray-0")};
          outline-offset: ${semanticVar("border-width-focus-offset")};
        }
        li.highlighted:not(:disabled):hover {
          background: ${listItemVar("open-hover-background-color")};
          box-shadow: ${listItemVar("open-hover-box-shadow")};
        }
      }
    `,
];
export const NAV_TREE_NODE_TAG = "atlas-gn-nav-tree-node";
defineComponent(NAV_TREE_NODE_TAG, NavTreeNode);
